import { createNamespacedHelpers } from 'vuex';

const mapState = createNamespacedHelpers('ux').mapState;

export default {

    computed: {
        ...mapState({
            useProfile: state => state.useProfile
        })
    },

    methods: {
        /**
         * Current `UseProfile` state.
         * Url query UseProfile overrides
         */
        getUseProfile: function () {
            return this.useProfile;
        },

        /**
         * Get `UseProfile` for Index View queries.
         *  ViewAll         > ViewAllCache
         *  ViewPublicOnly  > ViewPublicOnlyCache > ViewPublicOnly
         *  EditAll         > ViewAll
         */
        getUseProfile_ViewCache: function () {
            let useProfile = this.useProfile || '';
            if (useProfile.match('All')) {
                useProfile = 'ViewAll';
            }
            else {
                useProfile = 'ViewPublicOnly';
            }
            if (this.$store.getters['ux/getEditMode']) {
                // edit mode gets faster cache
                if (useProfile.match('All')) {
                    useProfile = 'EditAll';
                }
                else {
                    useProfile = 'EditPublicOnly';
                }
                return useProfile;
            }
            return useProfile ; // removed + 'Cache';
        }
    }
};
